module.exports = __webpack_public_path__ + "img/search-solid.32653347.svg";